module.exports = __webpack_public_path__ + "img/8.f139bfe4.png";